import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGridCarets = () => {
  return (
    <g>
      <path d="m6.98 2.1757h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7257 4.505a.3624.3624 0 0 0 .6746 0l2.7259-4.505c.1856-.3065.0441-.5574-.3144-.5574z" />
      <path d="m11.4315 7.2381a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3142-.5574h-5.4977c-.3584 0-.5.2508-.3143.5574z" />
      <path d="m6.98 8.532h-5.4976c-.3583 0-.5.2508-.3142.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1856-.3066.0441-.5574-.3144-.5574z" />
      <path d="m14.5176 8.532h-5.4976c-.3584 0-.5.2508-.3143.5574l2.7258 4.5049a.3624.3624 0 0 0 .6746 0l2.7258-4.5049c.1855-.3066.0441-.5574-.3143-.5574z" />
    </g>
  );
};

export default withIcon(IconGridCarets);
